<template>
  <div class="main-container">
    <!-- Author: Bhushan
      Date: 10/02/2021
      Description: Income Tax Proof components-->
   <!--  <breadcrumb :list="breadcrumbList" />  -->
  
    <div v-if="ifEmployee">
      <tl-header type="h1">Income Tax Proof Submission</tl-header>
      <div class="margintop-16" />
      <div class="row income-tax-summary-box">
        <div class="income-tax-text">Income Tax Summary</div>
        <div class="row">
          <div class="col-10-new">
            <div class="row">
              <div class="col-3 custom-col-3">
                <div class="sm-text-it-summary">Tax Regime</div>
                <div class="sm-sub-text-it-summary">Old Tax Regime</div>
              </div>
              <div class="col-3 custom-col-3">
                <div class="sm-text-it-summary">Net Taxable Income</div>
                <div class="sm-sub-text-it-summary">₹8,31,323.00</div>
              </div>
              <div class="col-3 custom-col-3">
                <div class="sm-text-it-summary">Total Tax</div>
                <div class="sm-sub-text-it-summary">₹92,321.00</div>
              </div>
              <div class="col-3 custom-col-3">
                <div class="sm-text-it-summary">Tax to be Paid</div>
                <div class="sm-sub-text-it-summary">₹32,232.00<span class="sm-sub-text-right">(42,423/ Month)</span></div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <!-- <btn text="Change" class="add-btn-sm" type="secondary"/> -->
            <div class="change-btn-color-text">Change</div>
            <div class="back-btn-color-text">Back</div>
          </div>
        </div>
      </div>
      <div class="row my-4">
        <div class="col-6 pl-0 cursor-point" @click="showPopupdependentsPopup = !showPopupdependentsPopup">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">Family Details</div>
              <div class="sub-heading-details-sm">
                Family Details.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupdependentsPopup"
              @back="showPopupdependentsPopup = !showPopupdependentsPopup"
              header="Dependents"
              >
                <template v-slot:content>
                  <dependents-popup
                  @back="showPopupdependentsPopup = !showPopupdependentsPopup"
                  @openNewDependents = "openNewDependents" 
                  >
                  </dependents-popup>
              </template>
          </pop-up-window-lg>
        <div class="col-6 pr-0 cursor-point" @click="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/home_rent_declartion.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">House Rent Declaration</div>
              <div class="sub-heading-details-sm">
                To claim House rent allowance(HRA), it is necessary to
                provide evidence of the payment of the rent to the employee.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupExemptionUnderSectionDeduction"
              @back="changeHeaderTitle"
              :header="exemptionSection"
              >
              <template v-slot:content>
                 <exemption-under-section-deduction @passPopupHeader="popupMessage"
                  @back="showPopupExemptionUnderSectionDeduction = !showPopupExemptionUnderSectionDeduction"
                  :section10="data2.exemption10"
                  @section10update="section10update"
                  >
                </exemption-under-section-deduction>
              </template>
        </pop-up-window-lg>
      </div>
      <div class="row my-4">
        <div class="col-6 pl-0 cursor-point" @click="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/deduction_under_80CD.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">Deduction under 80C, 80D</div>
              <div class="sub-heading-details-sm">
                Section 80C offers tax deductions on different types of 
                tax-saving investments, such as ULIP,PPF, premium, etc.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupDeductionUnderCdeu"
              @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
              header="Deduction Under Chapter VI A"
              >
                <template v-slot:content>
                  <deduction-under-cdeu 
                  @back="showPopupDeductionUnderCdeu = !showPopupDeductionUnderCdeu"
                  :chapterVIA="data2.deductionsUnderChapterVIA"
                  @chapterVIAupdate="chapterVIAupdate"
                  >
                  </deduction-under-cdeu>
              </template>
        </pop-up-window-lg>
        <div class="col-6 pr-0 cursor-point" @click="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeLossFromHousingProperty.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">Income/Loss from Housing Property</div>
              <div class="sub-heading-details-sm">
                A taxpayer can claim deduction under Section 24 of interest paid 
                on home loan for each of the houses separately.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupIncomeLossFromHousingProperty"
              @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
              header="Section 24A"
              >
                <template v-slot:content>
                  <income-loss-from-housing-property
                  @back="showPopupIncomeLossFromHousingProperty = !showPopupIncomeLossFromHousingProperty"
                        :Section24="data2.section24"
                        @Section24Update="Section24Update"
                  >
                  </income-loss-from-housing-property>
              </template>
        </pop-up-window-lg>
      </div>
      <div class="row my-4">
        <div class="col-6 pl-0 cursor-point" @click="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/incomeFromPreviousEmployer.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">Income from Previous Employer</div>
              <div class="sub-heading-details-sm">
                It's not mandatory that you should report your previous
                employer salary income and TDS amount deducted.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupIncomeFromPreviousEmployer"
              @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
              
              header="Income From Previous Employer"
              
              >
                <template v-slot:content>
                  <income-from-previous-employer 
                  @back="showPopupIncomeFromPreviousEmployer = !showPopupIncomeFromPreviousEmployer"
                  :previousEmploymentDetails="data2.previousEmploymentDetails"
                  @previousDataUpdate="previousDataUpdate"
                  >
                  </income-from-previous-employer>
              </template>
          </pop-up-window-lg>
        <div class="col-6 pr-0 cursor-point" @click="showPopupOtherIncome = !showPopupOtherIncome">
          <div class="row col-bg-gray">
            <div class="col-3 img-block">
              <img src="@/assets/other_income.svg"/>
            </div>
            <div class="col-7 img-block"> 
              <div class="heading-text">Other Income</div>
              <div class="sub-heading-details-sm">
                Other income is income that does not come from a company's
                main business, such as interest.
              </div>
            </div>
            <div class="col-2 arrow-left-align">
              <img class="arrow-icon-it" src="@/assets/arrow_purple_new.svg"/>
            </div>
          </div>
        </div>
        <pop-up-window-lg
              v-if="showPopupOtherIncome"
              @back="showPopupOtherIncome = !showPopupOtherIncome"
              header="Other Income"
              >
                <template v-slot:content>
                  <other-income
                  @back="showPopupOtherIncome = !showPopupOtherIncome"
                  :otherIncome="data2.otherIncome"
                  @otherIncomeUpdate="otherIncomeUpdate"
                  >
                  </other-income>
              </template>
        </pop-up-window-lg>
      </div>

      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Back" type="secondary" @click="goBack" />
            <btn text="Save" type="primary" @click="saveEssIT"/>
          </btn-grp>
        </template>
      </bottom-action-container>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`Save Successfully.`"
        btnText="OK"
        @back="goBack"
      ></pop-up-message>
    </div>
    <div v-else>
    <div class="margintop-16" />  
    <tl-header type="h1" class="employee-fullname">Income Tax Proof Submission: {{` ${employeeObj.first_name} ${employeeObj.last_name ? employeeObj.last_name:'' } `}}</tl-header>
    <div class=" lineheight"></div>
    <!-- Section 1 -->
    <div class="container-fluid" id="example">
        <div class="row">
            <div class="col-2 first">
                <div>
                    <div class="img-user">
                    <img src="@/assets/user.svg" class="oval" />
                    </div>
                              
                    <div class="month">
                        <div class="employee-fullname"> {{` ${employeeObj.first_name} ${employeeObj.last_name ? employeeObj.last_name :''} `}} </div>
                        <div class="employee-code"> {{ `${employeeObj.code}`}} </div>
                        <div class="date"></div>
                    </div>
                </div>
            </div>
            <div class="col-10-new last">
                <div class="row">
                    <div class="col-6 left-box-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="total-taxable-income">Planned Investment:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong>₹ {{`${totalPlannedInvestment}`}}</strong>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Actual Investment:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong> ₹ 0 </strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 right-box-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="total-taxable-income">Salary and Perks:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong>₹ {{annualIncome}}</strong>
                            </div>
                        </div> 
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Total Taxable Income:</div>
                            </div>
                            <div class="col-6 amount-right">
                                <strong> ₹ {{totalIncome}} </strong>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6">
                                <div class="total-taxable-income">Annual Tax:</div>
                            </div>
                            <div class="col-6 amount-right">
                               <strong> ₹ {{totalTax}} </strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="view-proof-title" @click="showPopupdependentsPopup = !showPopupdependentsPopup"><span class="view-proof-title-pointer">View Dependents</span></div>
                    </div>
                    <div class="col-4 side-hr-lr">
                        <div class="view-proof-title"><span class="view-proof-title-pointer">View TDS Breakup</span></div>
                    </div>
                    <div class="col-4">
                        <div class="view-proof-title"><span class="view-proof-title-pointer">View IT Statement</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end section 1 -->


    <!-- Income Tax Proof Form PLan Main section -->
    <div v-if="iTaxProofFormPlan">
      <!-- Section 2 -->
      <div class="container-fluid my-4">
        <div class="othersection">
          <div class="row">
            <div class="col-8">
                <div>
                  <img class="img-icon-success" src="@/assets/success.svg" alt />
                  <span class="success-title-proof">You have successfully submitted investment proofs for this employee.</span>
                </div>
            </div>
            <div class="col-4">
                <div class="edit-investment-plan" @click="editInvestmentPlan">
                  <span class="add-new-investment-pointer">
                    Click here to edit investment plan
                  </span>
                </div>
            </div>
          </div>
        </div>  
      </div>
      <div class="container-fluid my-4">
          <div class="row">
            <div class="col-6 pl-0">
              <strong>Approval Status</strong>
            </div>
            <div class="col-6 pr-0">
              <div class="add-new-investment" @click="showPopupviewDownloadFormsPopup = !showPopupviewDownloadFormsPopup"> 
                <span class="add-new-investment-pointer">
                View/Download Forms
                </span>
              </div>
            </div>
          </div>
      </div>
      <!-- end section 2 -->
    </div>
    <!-- End Income Tax Proof Form PLan Main Section -->

    <!-- Main section -->
    <div v-if="iTaxProofPlan">
      <!-- Section 2 -->
      <div class="container-fluid">
        <!-- IT Proof Enable -->
        <div class="bg-gray" v-if="!itEnableValue">
          <img class="warning-img" src="@/assets/warning.svg" alt />
          <span class="investment-alert-message">Income Tax Proof Submission window will be open {{ `${this.startDate}`}} to {{ `${this.endDate}`}} .</span>
        </div>
        <!-- IT Proof Enable End Here -->
        <div class="row my-4">
          <div class="col-4">
              <div class="deduction-title">
                Submit Proofs for Tax Saving Investments
              </div>
          </div>
          <div class="col-4">
              <span class="total-taxable-income">  </span>
          </div>
          <!-- <div class="col-4">
              <div class="add-new-investment" @click="showPopupaddNewInvestmentPopup = !showPopupaddNewInvestmentPopup">
                <span class="add-new-investment-pointer">
                <img class="img-icon" src="@/assets/circle-cross.svg" alt />
                Add New Investment
                </span>
              </div>
          </div> -->
        </div>
      </div>
    </div>  
      <!-- end section 2 -->
    <!-- End Main Section -->  
      
      <!-- Section 3 -->
      <tl-accordion headerName="Section 10">
        <div slot="accordionBody">
          <div class="container-fluid my-2" :disabled="!itEnableValue">
            <data-table
                  :columns="tableColumnsSection10"
                  :tableData="section10List"
                  :checkbox="false"
                  :withForm="false"
                  :showhistory="false"
                  :showdelete="false"
                  @editStart="editSection10($event)"
                  @delete="deleteItemSection10"
                  >
                      <template v-slot:rowcontent="slotprops">
                        <div>
                          <p
                                    v-if="slotprops.value.column.key == 'slno'"
                                  >{{slotprops.value.index+1}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'particulars'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'limits'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                                  <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="section10List[slotprops.value.index].planned"
                                    />
                                    <!-- <span v-else>-</span> -->
                                  </p>
                                  <p v-if="slotprops.value.column.key=='actual'">
                                    <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="section10List[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span>
                                  </p>
                                  <p v-if="slotprops.value.column.key=='file_location'">
                                    <a
                                      href="javascript:void(0)"
                                      v-if="slotprops.value.record['file_location']"
                                      @click="openDocModal(section10List[slotprops.value.index].file_location, '')"
                                    ><img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                                    {{slotprops.value.record['file_location'].length }} attachment</a>
                                    <span v-else>-</span>
                                  </p>
                                  
                                    <div v-if="iTaxProofFormPlan">
                                    <p
                                    v-if="slotprops.value.column.key == 'status'"
                                  >{{slotprops.value.record.status}}</p>
                                    </div>
                        </div>
                      </template>
            </data-table>
          </div>
        </div>
      </tl-accordion>      
      <!-- end section 3 -->

      <!-- Section 4 -->
      <!-- first comment section start by bhushan -->
      <!-- <tl-accordion headerName="Section 17">
        <div slot="accordionBody">
          <div class="container-fluid mt-3 mb-2" :disabled="!itEnableValue">
            <data-table
                  :columns="tableColumnsSection17"
                  :tableData="section17List"
                  :checkbox="false"
                  :withForm="false"
                  :showhistory="false"
                  :showdelete="false"
                  @editStart="editSection17($event)"
                  @delete="deleteItemSection17"
                  >
                      <template v-slot:rowcontent="slotprops">
                        <div>
                          <p
                                    v-if="slotprops.value.column.key == 'slno'"
                                  >{{slotprops.value.index+1}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'particulars'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'limits'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                                  <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="section17List[slotprops.value.index].planned"
                                    />  -->
                                    <!-- first comment section end by bhushan -->
                                    <!-- <span v-else>-</span> -->
                                  <!-- Second comment section start by bhushan -->
                                  <!-- </p>
                                  <p v-if="slotprops.value.column.key=='actual'">
                                    <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="section17List[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span>
                                  </p>
                                  <p v-if="slotprops.value.column.key=='file_location'">
                                    <a
                                      href="javascript:void(0)"
                                      v-if="slotprops.value.record['file_location']"
                                      @click="openDocModal(section17List[slotprops.value.index].file_location, '')"
                                    ><img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                                    {{slotprops.value.record['file_location'].length }} attachment</a>
                                    <span v-else>-</span>
                                  </p>
                                  
                                    <div v-if="iTaxProofFormPlan">
                                    <p
                                    v-if="slotprops.value.column.key == 'status'"
                                  >{{slotprops.value.record.status}}</p>
                                    </div>
                        </div>
                      </template>
            </data-table>
          </div>   
        </div>
      </tl-accordion>   -->
      <!-- Second comment section end by bhushan --> 
      <!-- end section 4 -->

      <!-- Section 5 -->
      <tl-accordion headerName="80C (Chapter VI A)">
        <div slot="accordionBody">
          <div class="container-fluid mt-3 mb-2" :disabled="!itEnableValue">
            <data-table
                  :columns="tableColumns80C"
                  :tableData="data80CList"
                  :checkbox="false"
                  :withForm="false"
                  :showhistory="false"
                  :showdelete="false"
                  @editStart="editChapterVIA($event)"
                
                  @delete="deleteItem80C"
                  >
                  <template v-slot:rowcontent="slotprops">
                                <div>
                                  <p
                                    v-if="slotprops.value.column.key == 'slno'"
                                  >{{slotprops.value.index+1}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'particulars'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                                  <p
                                    v-if="slotprops.value.column.key == 'limits'"
                                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                                  <p v-if="slotprops.value.column.key=='planned'">
                                    <txt
                                      type="number"
                                      :disable="true"
                                      :name="'explannedvalue'+slotprops.value.index"
                                      v-model="data80CList[slotprops.value.index].planned"
                                    />
                                    <!-- <span v-else>-</span> -->
                                  </p>
                                  <p v-if="slotprops.value.column.key=='actual'">
                                    <txt
                                      v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                      type="number"
                                      :disable="false"
                                      :name="'exactualvalue'+slotprops.value.index"
                                      v-model="data80CList[slotprops.value.index].actual"
                                    />
                                    <span v-else>-</span>
                                  </p>
                                  <p v-if="slotprops.value.column.key=='file_location'">
                                    <a
                                      href="javascript:void(0)"
                                      v-if="slotprops.value.record['file_location']"
                                      @click="openDocModal(data80CList[slotprops.value.index].file_location, '')"
                                    ><img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                                    {{slotprops.value.record['file_location'].length }} attachment</a>
                                    <span v-else>-</span>
                                  </p>
                                  
                                    <div v-if="iTaxProofFormPlan">
                                    <p
                                    v-if="slotprops.value.column.key == 'status'"
                                  >{{slotprops.value.record.status}}</p>
                                    </div>
                                </div>
                              </template>
                      <!-- <template v-slot:rowcontent="slotprops">
                          <p
                          v-if="slotprops.value.column.key === 'particulars'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p
                          v-if="slotprops.value.column.key ==='yearly_limit'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p
                          v-if="slotprops.value.column.key ==='planned_investment'"
                          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
                          <p v-if="slotprops.value.column.key=='actual_investment'">
                          <txt
                            type="number"
                            :disable="true"
                            :name="'oivalue'+slotprops.value.index"
                            v-model="data80CList[slotprops.value.index].actual"
                          />
                        </p>
                        <p v-if="slotprops.value.column.key == 'proofs_attachment'">
                          <a
                            href="javascript:void(0)"
                            v-if="slotprops.value.record[slotprops.value.column.key]"
                            @click="openDocModal80C(slotprops.value)"
                          ><img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                          <span class="attachment-text">{{slotprops.value.record[slotprops.value.column.key].length }} attachment</span>
                          </a>
                        </p>
                      </template> -->
                      
            </data-table>
          </div> 
        </div>
      </tl-accordion>
      <!-- end section 5 -->

     
         <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Section 24 (Housing Loan)</div>
              <div class="col-6 align-right"></div>
            </div>
          </template>
          <template v-slot:accordionBody>
          <div :disabled="!itEnableValue">
            <div class="datatable-outer-container">
              <table class="datatable">
                <thead>
                  <tr class="header-row">
                    <th>(i)Interest on housing loan (Self occupied)</th>
                    <th>Planned</th>
                    <th>Actual</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tr
                  v-for="(item, index) in section24.self_occupied.selfOccupied"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'soplanned'+index"
                      :disable="true"
                      v-model="item.planned"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'soactual'+index"
                      v-model="item.actual"
                      @change="sumSelfOccupied()"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_planned"
                      :disable="true"
                      v-model="section24.self_occupied.total_planned"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_actual"
                      :disable="true"
                      v-model="section24.self_occupied.total_actual"
                    />
                  </td>
                  <td>
                     <a
                      href="javascript:void(0)"
                      @click="openDocModal(section24.self_occupied.proof, 'self-occupied')"
                    >{{section24.self_occupied.proof.length }} attachment</a>
                  </td>
                 
                  <td>
                    <label class="fileLabel" :for="'sfile'+0">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        class="uploadingFile"
                        type="file"
                        :id="'sfile'+0"
                        @change="uploadFile($event.target.files[0], 0, 'Section24-self')"
                      />
                    </label>
                     <p class="filtering">(jpeg, jpg or png)</p>
                  </td>
                </tr>
              </table>
            </div>
            <div class="d-payroll__accord margin-t-m">
              <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveHLOthers = !isActiveHLOthers"
                >Self - Decaration for Joint Property</div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <div class="row">
                          <div class="col-4">
                            <txt
                              label="Name of Joint Holder"
                              name="joint_holder_name"
                              v-model="section24.self_occupied.joint_holder_name"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Relationship"
                              name="relationship"
                              v-model="section24.self_occupied.relationship"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                          <div class="col-4">
                            <txt
                              name="tax_benefit"
                              type="number"
                              v-model="section24.self_occupied.tax_benefit"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(letout, index) in section24.let_out_property" :key="index">
              <div class="row">
                <div class="col-12 align-right" v-if="section24.let_out_property.length > 1">
                  <a class="delete-btn" @click="deleteLetOut(index)">
                    <img src="@/assets/delete.svg" />
                    <span>Delete LetOut Property</span>
                  </a>
                </div>
              </div>
              <div class="datatable-outer-container">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>(ii)Income/loss from house property (Letout)</th>
                      <th>Planned</th>
                      <th>Actual</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tr v-for="(item, idx) in letout.letOut" :key="idx" class="record-row">
                    <td>{{item.name}}</td>
                    <td>
                      <txt
                        type="number"
                        :name="'loplanned'+idx"
                        :disable="true"
                        v-model="item.planned"
                      />
                    </td>
                    <td>
                      <txt
                        type="number"
                        v-if="!item.isCalculate"
                        :name="'loactual'+idx"
                        v-model="item.actual"
                        @change="sumLetOutActual(index)"
                        :disable="item.isDisabled"
                      />
                      <txt
                        type="number"
                        v-else
                        :name="'loactual'+idx"
                        v-model="item.actual"
                        @change="calculateOther(index, idx, item.name); sumLetOutActual(index)"
                        :disable="item.isDisabled"
                      />
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="record-row">
                    <td>
                      <b>Total</b>
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'totalletoutPlanned'+index"
                        :disable="true"
                        v-model="letout.total_planned"
                      />
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'totalletoutActual'+index"
                        :disable="true"
                        v-model="letout.total_actual"
                      />
                    </td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        @click="openDocModal(letout.proof, index, 'letout')"
                      >{{letout.proof.length }} attachment</a>
                    </td>
                    <td>
                      <label class="fileLabel" :for="'lfile'+index">
                        <img src="@/assets/group-5.svg" class="plus-icon" />
                        <input
                          class="uploadingFile"
                          type="file"
                          :id="'lfile'+index"
                          @change="uploadFile($event.target.files[0], index, 'Section24-letout')"
                        />
                      </label>
                      <p class="filtering">(jpeg, jpg or png)</p>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="datatable-outer-container">
                <table class="datatable">
                  <tbody>
                    <tr class="record-row">
                      <td>
                        <b>Total Exemption</b>
                        <p>Either 2 Lakhs or (i+ii)</p>
                      </td>
                      <td>
                        <txt type="number" name="totalPlanned" :disable="true" />
                      </td>
                      <td>
                        <txt type="number" name="totalPlanned" :disable="true" />
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-payroll__accord margin-t-m">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHLOthers = !isActiveHLOthers"
                  >Self - Decaration for Joint Property</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="col-12">
                        <div class="icon">
                          <div class="row">
                            <div class="col-4">
                              <txt
                                label="Name of Joint Holder"
                                :name="'letout_joint_holder_name'+index"
                                v-model="letout.joint_holder_name"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Relationship"
                                :name="'letout_relationship'+index"
                                v-model="letout.relationship"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                            <div class="col-4">
                              <txt
                                type="number"
                                :name="'tax_benefit'+index"
                                v-model="letout.tax_benefit"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div class="row-container align-center">
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button class="text-green" @click="addMoreLetOut()">Add More Housing Properties</button>
                </div>
              </div>
            </div>
          </div>  
          </template>
        </tl-accordion>
     <!-- <tl-accordion :disabled="!isOtherIncomeAllowed"> this will enable when we check -->
       <tl-accordion >
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Other Income</div>
              <div class="col-6 align-right"></div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <data-table
              :columns="otherIncTableColumns"
              :tableData="otherIncomeList"
              :withForm="false"
              :showinrow="false"
              :disabled="!itEnableValue"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p v-if="slotprops.value.column.key == 'slno'">{{slotprops.value.index+1}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'particulars'"
                  >{{slotprops.value.record['name']}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :disable="true"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].planned"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='actual'">
                    <txt
                      type="number"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].actual"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key == 'proof'">
                    <a
                      href="javascript:void(0)"
                      v-if="slotprops.value.record[slotprops.value.column.key]"
                      @click="openDocModal(otherIncomeList[slotprops.value.index].proof, slotprops.value.index, 'other-income')"
                    >{{slotprops.value.record[slotprops.value.column.key].length }} attachment</a>
                  </p>
                  <p v-if="slotprops.value.column.key == 'action'">
                    <label class="fileLabel" :for="'ofile'+slotprops.value.index">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'ofile'+slotprops.value.index"
                        @change="uploadFile($event.target.files[0], slotprops.value.index, 'otherIncome')"
                      />
                    </label>
                  </p>
                </div>
              </template>
            </data-table>
          </template>
        </tl-accordion>
    
    
       <!-- <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Previous Employment Details</div>
              <div class="col-6 align-right"></div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <ul class="table-header header-table">
              <li class="table-header-item">Particulars</li>
              <li class="table-header-item">Amount</li>
              <li class="table-header-item">Proofs</li>
              <li class="table-header-item"></li>
            </ul>
            <div class="row-div" :disabled="!itEnableValue">
              <ul class="table-row">
                <li class="table-row-item">Salary Income After Section 10</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    name="salary_income"
                    v-model="previousEmploymentDetails.salary_income.amount"
                  />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.salary_income.location, 'salary-income')"
                  >{{previousEmploymentDetails.salary_income.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="salary_income">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="salary_income"
                      @change="uploadPEProof($event.target.files[0], 'salary_income' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PT Amount</li>
                <li class="table-row-item">
                  <txt type="number" name="pt" v-model="previousEmploymentDetails.pt.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.pt.location, 'pt')"
                  >{{previousEmploymentDetails.pt.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="pt">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="pt"
                      @change="uploadPEProof($event.target.files[0], 'pt' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">VPF</li>
                <li class="table-row-item">
                  <txt type="number" name="vpf" v-model="previousEmploymentDetails.vpf.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.vpf.location, 'vpf')"
                  >{{previousEmploymentDetails.vpf.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="vpf">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="vpf"
                      @change="uploadPEProof($event.target.files[0], 'vpf' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PF</li>
                <li class="table-row-item">
                  <txt type="number" name="pf" v-model="previousEmploymentDetails.pf.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.pf.location, 'pf')"
                  >{{previousEmploymentDetails.pf.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="pf">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="pf"
                      @change="uploadPEProof($event.target.files[0], 'pf' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">NPS</li>
                <li class="table-row-item">
                  <txt type="number" name="nps" v-model="previousEmploymentDetails.nps.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.nps.location, 'nps')"
                  >{{previousEmploymentDetails.nps.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="nps">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="nps"
                      @change="uploadPEProof($event.target.files[0], 'nps' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">Income Tax Deduction</li>
                <li class="table-row-item">
                  <txt type="number" name="tds" v-model="previousEmploymentDetails.tds.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.tds.location,'tds')"
                  >{{previousEmploymentDetails.tds.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="tds">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="tds"
                      @change="uploadPEProof($event.target.files[0], 'tds' )"
                    />
                  </label>
                </li>
              </ul>
            </div>
          </template>
        </tl-accordion> -->

     <div class="modal custom-modal" v-if="showDocModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <div class="row">
            <div class="col-12">
              <h3>Documents</h3>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="carousel">
            <img :src="docUrl" alt class="docImage" />
            <div class="text-center">
              <a href="javascript:void(0)" @click="prev()" class="arrow arrow-prev">&lt;</a>
              <a href="javascript:void(0)" @click="next()" class="arrow arrow-next">&gt;</a>
            </div><br>
            <div class="text-center my-3">
              <span class="delete-download add-new-document">
                <a
                  href="javascript:void(0)"
                  v-if="showDeleteDoc"
                  class="close-btnn"
                  style="text-decoration: none;"
                  @click="deleteDoc(index)"
                >Delete</a>
              </span>
              <sapn class="delete-download add-new-document">
                <a :href="docUrl" download="file" style="text-decoration: none;" class="close-btnn">
                  <img src="@/assets/download.svg" class="img" />&nbsp;
                  <span class="text">Download</span>
                </a>
              </sapn>
            </div>  
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <!-- <div class="col-6 text-left">
              <a
                href="javascript:void(0)"
                v-if="showDeleteDoc"
                class="close-btn"
                @click="deleteDoc(index)"
              >Delete</a>
            </div> -->
            <div class="col-12">
              <!-- <a :href="docUrl" download="file" class="close-btn">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download</span>
              </a> -->
              <btn 
              text="Close" 
              type="secondary" 
              class="btn-lg" 
              @click="okbtn" />    
                
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup 1 -->


    <pop-up-window
        v-if="showPopupdependentsPopup"
        @back="showPopupdependentsPopup = !showPopupdependentsPopup"
        header="Dependents"
        >
          <template v-slot:content>
            <dependents-popup
            @back="showPopupdependentsPopup = !showPopupdependentsPopup"
            @openNewDependents = "openNewDependents" 
            >
            </dependents-popup>
         </template>
    </pop-up-window>
    <!-- End -->
    <!-- Popup 2 -->
    <pop-up-window
        v-if="showPopupaddDependentsPopup"
        @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
        header="Dependents"
        >
          <template v-slot:content>
            <add-dependents-popup
            @back="showPopupaddDependentsPopup = !showPopupaddDependentsPopup"
            @saveDependent = "saveDependent"
            >
            </add-dependents-popup>
         </template>
    </pop-up-window>
    <!-- End -->
    <!-- Popup 3 -->
    <pop-up-window
        v-if="showPopupaddNewInvestmentPopup"
        @back="showPopupaddNewInvestmentPopup = !showPopupaddNewInvestmentPopup"
        header="Add New Investments"
        >
          <template v-slot:content>
            <add-new-investment-popup
            @back="showPopupaddNewInvestmentPopup = !showPopupaddNewInvestmentPopup"
            
            >
            </add-new-investment-popup>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Popup 4 -->
    <pop-up-window
        v-if="showPopupviewDownloadFormsPopup"
        @back="showPopupviewDownloadFormsPopup = !showPopupviewDownloadFormsPopup"
        header="Self Declared Forms"
        >
          <template v-slot:content>
            <view-download-forms-popup
            @back="!openFullDocument && !showPopupviewDownloadFormsPopup"
            :formList="formList"
            >
            </view-download-forms-popup>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Popup 6 -->
    <pop-up-window
        v-if="showPopupuploadAttachment"
        @back="showPopupuploadAttachment = !showPopupuploadAttachment"
        header="Document"
        >
          <template v-slot:content>
            <upload-attachment
              @selectedAttachment="openFullAttachment"
              @back="!openFullAttachment && !showPopupuploadAttachment"
              :docsList="docsList"
              :title="title"
            >
            </upload-attachment>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Popup 7 -->
    <!-- <pop-up-window
        v-if="showPopupfullAttachmentShow"
        @back="showPopupfullAttachmentShow = !showPopupfullAttachmentShow"
        header="Co-owner Pan Card"
        >
          <template v-slot:content>
            <full-attachmentShow
            @back="showPopupfullAttachmentShow = !showPopupfullAttachmentShow"
            >
            </full-attachmentShow>
         </template>
    </pop-up-window> -->
    <!-- End -->

    <!-- Popup 8 -->
    <pop-up-window
        v-if="showPopupsection10Popup"
        @back="showPopupsection10Popup = !showPopupsection10Popup"
        :header="title"
        
        >
          <template v-slot:content>
            <section10-popup
            @back="showPopupsection10Popup = !showPopupsection10Popup"
            :section10="section10record"
            @section10PopupUpdate="section10PopupUpdate"
            @hidemodal="cancelHide"
            >
            </section10-popup>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Popup 9 -->
    <pop-up-window
        v-if="showPopupsection17Popup"
        @back="showPopupsection17Popup = !showPopupsection17Popup"
        :header="title"
        >
          <template v-slot:content>
            <section17-popup
            @back="showPopupsection17Popup = !showPopupsection17Popup"
             :section17="section17record"
            @section17PopupUpdate="section17PopupUpdate"
            @hidemodal="cancelHide"
            >
            </section17-popup>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Popup 9 -->
    <pop-up-window
        v-if="showPopupChapterVIAPopup"
        @back="showPopupChapterVIAPopup = !showPopupChapterVIAPopup"
        :header="title"
        >
          <template v-slot:content>
            <chapterVIA-popup
            @back="showPopupChapterVIAPopup = !showPopupChapterVIAPopup"
            :section6a="section6arecord"
            @section6aPopupUpdate="section6aPopupUpdate"
            @hidemodal="cancelHide"
            >
            </chapterVIA-popup>
         </template>
    </pop-up-window>
    <!-- End -->

    <!-- Delete popup message -->
    <pop-up-message
      v-if="showDeleteConfirmation"
      :message="'Are you sure? This will be removed from your investment plan.'"
      popupHeaderMessage="Warning"
      :popupType="'Warning'"
      @back="backFromPopup"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="backFromPopup()">Cancel</button>
          <button class="btn-popup" type="button" @click="deleteInvestment">Yes</button>
        </div>
      </template>
    </pop-up-message>
    <!-- End -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="backpreviouspage" />
          <btn text="Submit Proofs" type="primary" v-show="submitProofBtnHide" @click="submitProofs"/>
        </btn-grp>
      </template>
    </bottom-action-container>
   </div> 
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import dependentsPopup from "./dependentsPopup.vue";
import addDependentsPopup from "./addDependentsPopup.vue";
import addNewInvestmentPopup from "./addNewInvestmentPopup.vue";
import viewDownloadFormsPopup from "./ViewDownloadFormsPopup.vue";
import uploadAttachment from "./uploadAttachment.vue";
import fullAttachmentShow from "./fullAttachmentShow.vue";
import { eventBus } from "@/main";
import section10Popup from "./section10Popup.vue";
import section17Popup from "./section17Popup.vue";
import ChapterVIAPopup from "./ChapterVIAPopup.vue";
import {
  get_axios_file_instance,
  api_variables,
  errorHandler
} from "@/apis/variables.js";

import ExemptionUnderSectionDeduction from "./exemptionUnderSectionDeduction.vue";
import DeductionUnderCdeu from "./deductionsUnderCdeu.vue";
import IncomeFromPreviousEmployer from "./incomeFromPreviousEmployer";
import OtherIncome from "./otherIncome.vue";
import IncomeLossFromHousingProperty from "./incomeLossFromHousingProperty.vue";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  name: "incometaxproofplan",
  components: {
    dependentsPopup,
    addDependentsPopup,
    addNewInvestmentPopup,
    viewDownloadFormsPopup,
    uploadAttachment,
    fullAttachmentShow,
    section10Popup,
    section17Popup,
    ChapterVIAPopup,
    ExemptionUnderSectionDeduction,
    DeductionUnderCdeu,
    IncomeFromPreviousEmployer,
    OtherIncome,
    IncomeLossFromHousingProperty
  },
  data() {
    return {
      showDocModal:false,
      employeeObj: null,
      showConfirmationMsg: false,
      personal: {
        first_name: null,
        last_name: null,
        code: null,
      },
      title:null,
      salary: {
        ctc: null,
        salary_structure_id: null,
        exempt_for_it_deduction_first_month: false,
        master_salary_structure: []
      },
      it_plan_id:"",
      employeeId:"",
      instance:{
        le_id:"",
        employee_id:"",
        financial_year:"",
        it_plan_id:"",
      },
      data2:{
       exemption10: {
        HRA: [
          {
            address: "",
            pincode: "",
            State: "",
            cityType: "metro",
            rentList: [
              {
                rentFrom: "",
                rentTo: "",
                amount: 0,
                agreementDoc: "",
                fileName: ""
              }
            ],
            ownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: "",
              fileName: "",
              isCoOwner: false,
              cownerDetails: {
                name: "",
                pan_number: "",
                pincode: "",
                address: "",
                state: "",
                pancardUrl: "",
                fileName: ""
              }
            }
          }
        ],
        others: []
      },
      exemption17:[],
      deductionsUnderChapterVIA:[],
      section24:[],
      previousEmploymentDetails:{},
      deductionsUnderSection16:{
        Section16:null
      },
      otherIncome:[],
      le_id:"",
      employee_id:"",
      financial_year:"",
      plan_id:"",
      regime_type:"",
      },
      section10Update:[],
      
      salaryPerk:[],
      tds_breakup_and_taxable_income:[],
      itSheet:[],
      first_name:"",
      last_name: "",
      ctc:"",
      code:"",
      totalIncomeTax:"",
      annualIncome:0,
      incomeTax:0,
      totalIncome:0,
      totalTax:0,
      showPopupdependentsPopup: false,
      showPopupaddDependentsPopup: false,
      showPopupaddNewInvestmentPopup: false,
      showPopupviewDownloadFormsPopup: false,
      showPopupfullviewDownloadFormsPopup: false,
      showPopupuploadAttachment: false,
      showPopupfullAttachmentShow:false,
      showPopupsection10Popup: false,
      salaryTableColumns: [],
      deductionsList: [],
      perksList: [],
      salaryList: [],
      data80CList: [],
      chapterOtherDataList: [],
      showPopupsection17Popup: false,
      showPopupChapterVIAPopup: false,
      section10record:[],
      section17record:[],
      section6arecord:[],
      tableColumnsSection10: [
                {
                label: "SL No.",
                 key: "slno"
                },{
                label: "Particulars",
                key: "particulars"
                },
               
                {
                label: "Planned Investment(₹)",
                key: "planned"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual"
                },
                {
                label: "Proofs",
                key: "file_location"
                },
                {
                label: "Status",
                key: "status"
                },
      ],
      section10List: [],
      tableColumnsSection17: [
                 {
                label: "SL No.",
                key: "slno"
                },{
                label: "Particulars",
                key: "particulars"
                },
               
                {
                label: "Planned Investment(₹)",
                key: "planned"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual"
                },
                {
                label: "Proofs",
                key: "file_location"
                },
                {
                label: "Status",
                key: "status"
                },
      ],
      section17List: [],
      tableColumns80C: [
                {
                label: "SL No.",
                 key: "slno"
                },{
                label: "Particulars",
                key: "particulars"
                },
               
                {
                label: "Planned Investment(₹)",
                key: "planned"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual"
                },
                {
                label: "Proofs",
                key: "file_location"
                },
                {
                label: "Status",
                key: "status"
                },
      ],
      tableColumnsotherIncome: [
                {
                label: "Particulars",
                key: "particulars"
                },
                {
                label: "Yearly Limit",
                key: "yearly_limit"
                },
                {
                label: "Planned Investment(₹)",
                key: "planned_investment"
                },
                {
                label: "Actual Investment(₹)",
                key: "actual_investment"
                },
                {
                label: "Proofs",
                key: "proofs_attachment"
                },
      ],
     
      iTaxProofPlan: true,
      iTaxProofFormPlan: false,
      showDeleteConfirmation: false,
      section10sum:0,
      section17sum:0,
      chapter6asum:0,
      section24sum:0,
      otherincomesum:0,
      totalPlannedInvestment:0,

       section24: {
        let_out_property: [
          {
            letOut: [],
            total_planned: 0,
            total_actual: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
          }
        ],
        self_occupied: {
          selfOccupied: [],
          total_planned: 0,
          total_actual: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        }
      },
      previousEmploymentDetails: {
        salary_income: { amount: 0, location: [] },
        pt: { amount: 0, location: [] },
        vpf: { amount: 0, location: [] },
        pf: { amount: 0, location: [] },
        nps: { amount: 0, location: [] },
        tds: { amount: 0, location: [] }
      },
       otherIncomeList: [
        {
          name: "Interest From saving Accounts",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Interest From Fixed Deposits",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Any other Income",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          file_location: "",
          status: "",
          type: ""
        }
      ],
        otherIncTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Planned",
          key: "planned"
        },
        {
          label: "Actual",
          key: "actual"
        },
        {
          label: "Proofs",
          key: "proof"
        },
        {
          label: "",
          key: "action"
        }
      ],
      submitProofBtnHide: true,
      formList: [],
      itEnableValue: false,
      startDate: "",
      endDate: "",
      showSuccessMsg: false,
      showPopupExemptionUnderSectionDeduction: false,
      showPopupDeductionUnderCdeu: false,
      showPopupIncomeLossFromHousingProperty: false,
      showPopupIncomeFromPreviousEmployer: false,
      showPopupOtherIncome: false,
      exemptionSection: "Exemption Under Section 10",
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getleData: "onboard/legal_entities/record",
      getITSettingsData: "onboard/statutoryinfo/incometax/getITData"
    }),
    ...mapState({
      globalData: state => state.globalapi.globalData.data,
      payrollYear: state => state.payroll.runpayroll.payrollYear
         }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHR() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    },
  },

  mounted() {
    this.fetechAllNewInvestment();
    this.itEnable();
  },
  activated() {
   this.fetechAllNewInvestment();
   this.itEnable();
  },

  created() {
    eventBus.$on('showsubmitproof', this.iTaxProofFormPlanShow);
  
  },
  methods: {
    ...mapActions({
      act_fetchEmpById: "onboard/employees/fetchEmpDataById",
      fetchEmployeeCode: "onboard/employees/fetchEmployeeCode",
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_fetchsalarycomponents:
        "onboard/settings/salary_component/fetchAllsalaryComponentsData",
      act_set_it_data:"dashboard/payroll/incometax/setItData",  
      act_save_it_plan:"dashboard/payroll/incometax/createItData",
      act_get_active_it_plan:"dashboard/payroll/incometax/getActiveList",
      act_get_it_enable:"dashboard/payroll/incometax/getItEnable"
    }),


  async fetechAllNewInvestment() {
        //console.log("Hello");
        let empId = this.$route.query.id;
        this.instance.employee_id = empId;
        let payload ={
          empId:empId,
          empLeId:this.le_id
        }
        let employeeDetail = await this.act_fetchEmpById(payload);
        this.employeeObj = employeeDetail.data.payload.data;
         this.empCtc=this.employeeObj.EmployeeSalarySetting[0].ctc
        //console.log("Employee Details Fetch All", employeeDetail.data.payload.data);
        this.instance.employee_id=empId;
        this.instance.financial_year=this.payrollYear
        this.instance.le_id=this.le_id;
      let res = await this.act_get_active_it_plan(empId);
       this.instance.it_plan_id=res.data.payload.id;
       this.formList=res.data.payload.future_declaration_files;
      ////console.log("response active plan",res);
      ////console.log(" instance",this.instance);
      this.fetchItData();
  },

  async fetchItData(){

    let res = await this.act_set_it_data(this.instance);

    
      if (res.data.status) {
          this.salaryList = [];
          this.deductionsList = [];
          this.perksList = [];
          let obj = res.data.payload;
          //console.log("complete obj data.",obj);
          this.totalTax=obj.itSheet[0].totalTax;
          this.totalIncome=(obj.itSheet[0].taxableIncome).toFixed();
          this.incomeTax=obj.itSheet[0].incomeTax;
          this.annualIncome=(obj.itSheet[0].totalEarning).toFixed();
          this.data80CList = [];
          this.section10List =[];
          this.section17List=[];
      this.data2.exemption10=obj.Exemption10;
      this.data2.exemption17= obj.Exemption17;
      this.data2.deductionsUnderChapterVIA=obj.deductionsUnderChapterVIA;
      this.data2.section24=obj.section24;
      this.data2.previousEmploymentDetails=obj.previousEmploymentDetails;
      this.data2.otherIncome=obj.otherIncome;
      this.data2.deductionsUnderSection16.Section16=obj.deductionsUnderSection16
      this.data2.le_id=obj.le_id;
      this.data2.employee_id=this.instance.employee_id;
      this.data2.financial_year=this.instance.financial_year;
            this.data2.plan_id=this.instance.it_plan_id;
          /* Section 10 data table push*/
          

          obj.Exemption10.others.forEach(element => {
              this.regime_type=element.regime_type;
              this.section10List.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
                
              });
             
          });
          
           /* Section 17 data table push*/
          obj.Exemption17.Section17.forEach(element => {
            
              this.section17List.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            
          });
          /* ChapterVIA data table push*/
          obj.deductionsUnderChapterVIA.forEach(element => {
            
              this.data80CList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
          });
          /* let out property data table push*/
          if (Object.keys(obj.section24).length && obj.section24.let_out_property !=null) {
            if (obj.section24.let_out_property.length) {
              this.section24.let_out_property = obj.section24.let_out_property;
            }
            this.section24.self_occupied = obj.section24.self_occupied;
            this.section24sum=this.section24.let_out_property.total_planned;
            
          }
         /* Other Income data table push*/
         if (obj.otherIncome.length) {
            this.otherIncomeList = obj.otherIncome;
             this.otherIncomeList.forEach(element => {
             this.otherincomesum += element.planned
            
          });
          }
           
            /* previous employment Details data table push*/
           if (Object.keys(obj.previousEmploymentDetails).length) {
            this.previousEmploymentDetails = obj.previousEmploymentDetails;
          }
           
          this.section10List.forEach(element =>{
            this.section10sum += element.planned
          })
          this.section17List.forEach(element =>{
            this.section17sum += element.planned
          })
          this.data80CList.forEach(element =>{
            this.chapter6asum += element.planned
          })
         
          this.totalPlannedInvestment=0;
      this.totalPlannedInvestment=(this.section10sum+this.section17sum+this.chapter6asum+this.otherincomesum).toFixed();
   // //console.log("total==========",this.totalPlannedInvestment);
         this.data2.exemption10.HRA = obj.Exemption10.HRA;
          
     }
         
  },
     calculatFY() {
      try {
        let d = new Date();
        let year = d.getFullYear();
        this.section24.self_occupied.selfOccupied = [
          {
            name: "Current Year Interest",
            planned: 0,
            actual: 0
          }
        ];
        for (let i = 1; i <= 5; i++) {
          let next_year = year - i;
          this.section24.self_occupied.selfOccupied.push({
            name: "Pre EMI Interest " + (year - i + "-" + (next_year + 1)),
            planned: 0,
            actual: 0
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateLetOutFy() {
      try {
        let d = new Date();
        let year = d.getFullYear();

        this.section24.let_out_property.forEach(element => {
          element.letOut = [
            {
              name: "Current Year Interest",
              planned: 0,
              actual: 0
            }
          ];
          for (let i = 1; i <= 5; i++) {
            element.letOut.push({
              name: "Pre EMI Interest FY" + i,
              planned: 0,
              actual: 0
            });
          }
          element.letOut.push(
            {
              name: "A Total rent received by employee",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "B Less: municipal Taxes Paid",
              planned: 0,
              actual: 0,
              isCalculate: true
            },
            {
              name: "C (A-B) Net Annual Value",
              planned: 0,
              actual: 0,
              isDisabled: true
            },
            {
              name: "D (C* 30%) Less: Standard Deduction @ 30%",
              planned: 0,
              actual: 0,
              isDisabled: true
            },
            {
              name: "E Less: Interest on Housing Loan",
              planned: 0,
              actual: 0,
              isDisabled: true
            },
            {
              name: "F (C-D-E) Income/Loss on House Property",
              planned: 0,
              actual: 0,
              isDisabled: true
            }
          );
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateOther(letOutIndex, rowIndex, name) {
      try {
        let obj1 = {};
        let index = 0;
        let obj2 = {};
        if (name == "A Total rent received by employee") {
          index = rowIndex + 2;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex + 1
          ];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
        } else {
          index = rowIndex + 1;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex - 1
          ];
        }
        this.section24.let_out_property[letOutIndex].letOut[index].actual =
          obj1.actual - obj2.actual;
        this.section24.let_out_property[letOutIndex].letOut[index + 1].actual =
          (30 *
            this.section24.let_out_property[letOutIndex].letOut[index].actual) /
          100;
        this.section24.let_out_property[letOutIndex].letOut[index + 3].actual =
          this.section24.let_out_property[letOutIndex].letOut[index].actual -
          this.section24.let_out_property[letOutIndex].letOut[index + 1]
            .actual -
          this.section24.let_out_property[letOutIndex].letOut[index + 2].actual;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumSelfOccupied() {
      try {
        let sum = 0;
        this.section24.self_occupied.selfOccupied.forEach(element => {
          sum += element.actual;
        });
        this.section24.self_occupied.total_actual = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumLetOutActual(index) {
      try {
        let sum = 0;
        this.section24.let_out_property[index].letOut.forEach(item => {
          sum += item.actual;
        });
        this.section24.let_out_property[index].total_actual = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDoc(index) {
      try {
        let url = this.docsList[index];
        if (this.currentFileSection == "chapter-others") {
          let idx = this.chapterOtherDataList[
            this.currentDocIndex
          ].file_location.findIndex(item => item == url);
          this.chapterOtherDataList[this.currentDocIndex].file_location.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "chapter-80C") {
          let idx = this.chapterDataList[
            this.currentDocIndex
          ].file_location.findIndex(item => item == url);
          this.chapterDataList[this.currentDocIndex].file_location.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "other-income") {
          let idx = this.otherIncomeList[this.currentDocIndex].proof.findIndex(
            item => item == url
          );
          this.otherIncomeList[this.currentDocIndex].proof.slice(idx, 1);
        }
        if (this.currentFileSection == "letout") {
          let idx = this.section24.let_out_property[
            this.currentDocIndex
          ].proof.findIndex(item => item == url);
          this.section24.let_out_property[this.currentDocIndex].proof.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "self-occupied") {
          let idx = this.section24.self_occupied.proof.findIndex(
            item => item == url
          );
          this.section24.self_occupied.proof.splice(idx, 1);
        }
        if (this.currentFileSection == "tds") {
          let idx = this.previousEmploymentDetails.tds.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.tds.location.splice(idx, 1);
        }
        if (this.currentFileSection == "nps") {
          let idx = this.previousEmploymentDetails.nps.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.nps.location.splice(idx, 1);
        }
        if (this.currentFileSection == "pf") {
          let idx = this.previousEmploymentDetails.pf.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.pf.location.splice(idx, 1);
        }
        if (this.currentFileSection == "vpf") {
          let idx = this.previousEmploymentDetails.vpf.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.vpf.location.splice(idx, 1);
        }
        if (this.currentFileSection == "pt") {
          let idx = this.previousEmploymentDetails.pt.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.pt.location.splice(idx, 1);
        }
        if (this.currentFileSection == "salary-income") {
          let idx = this.previousEmploymentDetails.salary_income.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.salary_income.location.splice(idx, 1);
        }
        this.docsList.splice(index, 1);
        if (index < this.docsList.length) {
          this.docUrl = this.docsList[index];
        } else if (index >= this.docsList.length) {
          if (!index && !this.docsList.length) {
            this.docUrl = "";
            this.showDocModal = false;
          } else {
            this.docUrl = this.docsList[index - 1];
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreLetOut() {
      try {
        this.section24.let_out_property.push({
          letOut: [],
          total_planned: 0,
          total_actual: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        });
        this.calculateLetOutFy();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteLetOut(index) {
      try {
        this.section24.let_out_property.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
      async uploadFile(docFile, index, category) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (category == "otherIncome") {
                this.otherIncomeList[index].proof.push(res.data.location);
              }
              if (category == "Section24-self") {
                this.section24.self_occupied.proof.push(res.data.location);
              }
              if (category == "Section24-letout") {
                this.section24.let_out_property[index].proof.push(
                  res.data.location
                );
              }
              if (category == "chapterVIAOthers") {
                if (this.chapterOtherDataList[index].file_location == null) {
                  this.chapterOtherDataList[index].file_location = [];
                }
                this.chapterOtherDataList[index].file_location.push(
                  res.data.location
                );
              }
              if (category == "chapterVIA") {
                if (this.chapterDataList[index].file_location == null) {
                  this.chapterDataList[index].file_location = [];
                }
                this.chapterDataList[index].file_location.push(
                  res.data.location
                );
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
     async uploadPEProof(docFile, item) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              this.previousEmploymentDetails[item].location.push(
                res.data.location
              );
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

  backpreviouspage() {
    if(this.ifHR || this.ifEmployee) {
        this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/overview`,
        });
      } else {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxProof`
      });
      window.location.reload();
    }
  },
    
  saveplan() {
      this.showConfirmationMsg = true;
  },

  /* function to hide the confimation pop-up */
  cancelEvent() {
      this.showConfirmationMsg = false;
  },

  openNewDependents() {
    this.showPopupdependentsPopup = false;
    this.showPopupaddDependentsPopup = true;
  },

  saveDependent() {
    this.showPopupdependentsPopup = true;
    this.showPopupaddDependentsPopup = false;
  },

  editInvestmentPlan() {
    this.iTaxProofPlan = true;
    this.iTaxProofFormPlan = false;
    this.submitProofBtnHide = true;
  },

   async iTaxProofFormPlanShow(res) {
     //console.log("insearch of emp",res);
    this.formlist = [];
    let res2 = await this.act_get_active_it_plan(res); 
      this.formlist=res2.data.payload.future_declaration_files;
    this.iTaxProofPlan = false;
    this.iTaxProofFormPlan = true;
    this.submitProofBtnHide = false;
  },

  deleteInvestment() {
    this.showDeleteConfirmation = false;
  },

  deleteItemSection10() {
    this.showDeleteConfirmation = true;
  },

  deleteItemSection17() {
    this.showDeleteConfirmation = true;
  },

  deleteItem80C() {
    this.showDeleteConfirmation = true;
  },

  backFromPopup() {
      this.showDeleteConfirmation = false;
  },

  async submitProofs() {

       this.data2.exemption10.others=this.section10List;
      this.data2.exemption17.Section17= this.section17List;
      this.data2.deductionsUnderChapterVIA=this.data80CList;
      this.data2.section24=this.section24;
      this.data2.previousEmploymentDetails=this.previousEmploymentDetails;
      this.data2.otherIncome=this.otherIncomeList;
      this.data2.regime_type=this.regime_type;
      //console.log("data before sending",this.data2);
        let res = await this.act_save_it_plan(this.data2);
      if(res.status){
        //console.log(res);
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofformplan`,
        query: { id: this.instance.employee_id }
      });
    }
  },

  // openFullDocument() {
  //     this.showPopupviewDownloadFormsPopup = false;
  //     this.showPopupfullviewDownloadFormsPopup = true;
  // },

  openFullAttachment() {
    this.showPopupuploadAttachment = false,
    this.showPopupfullAttachmentShow = true
  },

  openDocModal80C() {
    this.showPopupuploadAttachment = true;
  },

  openDocModalSection10() {
      this.showPopupuploadAttachment = true;
  },
    openDocModal(docList, index, section) {
      try {
        if (docList.length) {
          this.docsList = docList;
          this.docIndex = 0;
          this.index = 0;
          this.docUrl = this.docsList[0];
          this.currentDocIndex = index;
          this.showPopupuploadAttachment = true;
          this.currentFileSection = section;
        }
        if (section == "Section10") {
          this.showDeleteDoc = false;
        } else {
          this.showDeleteDoc = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
     okbtn() {
      this.showModal = false;
      this.showDocModal = false;
    },

  editSection10(record) {
    ////console.log("checking whats coming",record);
    this.section10record=record;
    this.title=record.InvestmentComponentType.name;
    this.showPopupsection10Popup = true;
  },

  editSection17(record) {
    this.section17record=record;
    this.title=record.InvestmentComponentType.name;
    this.showPopupsection17Popup = true;
  },

  editChapterVIA(record) {
     this.section6arecord=record;
    this.title=record.InvestmentComponentType.name;
    this.showPopupChapterVIAPopup = true;
  },

  section10PopupUpdate(section10Update,locationArray) {
     
        this.showPopupsection10Popup = false;
     if (section10Update) {
          let index = this.section10List.findIndex(element =>
            element.InvestmentComponentType.name == section10Update.InvestmentComponentType.name
          );
           let sum = 0;

          section10Update.details.forEach(element => {
            sum += element.amount;
          });
          this.section10List[index].actual = sum;
          this.section10List[index].details = section10Update.details;
          this.section10List[index].file_location = locationArray;
             // this.section10List[index].file_location== section10Update.details[0].proof[0];
         
        }
     //console.log("updated contents",this.section10List);
  },
  section17PopupUpdate(section17Update,locationArray) {
     
        this.showPopupsection17Popup = false;
     if (section17Update) {
          let index = this.section17List.findIndex(element =>
            element.InvestmentComponentType.name == section17Update.InvestmentComponentType.name
          );
           let sum = 0;

          section17Update.details.forEach(element => {
            sum += element.amount;
          });
          this.section17List[index].actual = sum;
          this.section17List[index].details = section17Update.details;
          this.section17List[index].file_location = locationArray;
             // this.section10List[index].file_location== section10Update.details[0].proof[0];
         
        }
     //console.log("updated contents",this.section17List);
  },

    section6aPopupUpdate(section6aUpdate,locationArray) {
     
        this.showPopupChapterVIAPopup = false;
     if (section6aUpdate) {
          let index = this.data80CList.findIndex(element =>
            element.InvestmentComponentType.name == section6aUpdate.InvestmentComponentType.name
          );
          let sum = 0;
            section6aUpdate.details.forEach(element => {
            sum += element.premium_amount;
          });
          this.data80CList[index].actual = sum;
          this.data80CList[index].details = section6aUpdate.details;
          this.data80CList[index].file_location = locationArray;
             // this.section10List[index].file_location== section10Update.details[0].proof[0];
         
        }
     //console.log("updated contents",this.data80CList);
  },

  cancelHide() {
    this.showPopupsection10Popup = false;
    this.showPopupsection17Popup = false;
    this.showPopupChapterVIAPopup = false;
  },

  async itEnable() {
      let res = await this.act_get_it_enable({le_id:this.le_id});
      let time = new Date().toISOString().slice(0, 10);
      let today = new Date(time);
      let dd = String(today.getDate()).padStart(2, '0');
      //let day = time.split('-').join('-');
      ////console.log("Day", dd);
      ////console.log("Time", time);
      
      /** Need End date also in IT proof submission */
      this.itEnableValue = res.data.payload.data.ITProofSetting.ITEnable;
      this.startDate = res.data.payload.data.ITProofSetting.startDate;
      this.endDate = res.data.payload.data.ITProofSetting.endDate;

      
      
      this.startValue = new Date(this.startDate);
      let start = String(this.startValue.getDate()).padStart(2, '0');
      ////console.log("Start", start);

      time >= this.startDate && time <= this.endDate ? this.itEnableValue = true : this.itEnableValue = false;
      //this.endDate = res.data.payload.data.ITDeclarationSetting.endDate;
      ////console.log("IT Proof Enable", this.itEnableValue,this.startDate);
  },

  
  section10update(Exemption10){
    this.showPopupExemptionUnderSectionDeduction=false;
    // //console.log("updated data ",Exemption10);
    this.data2.exemption10=Exemption10;
  },
    
  changeHeaderTitle() {
    this.exemptionSection = "Exemption Under Section 10";
    this.showPopupExemptionUnderSectionDeduction = false;
  },

  chapterVIAupdate(chapterData){
    this.showPopupDeductionUnderCdeu=false;
    //console.log("updated data chapter VI A",chapterData);
    this.data2.deductionsUnderChapterVIA=chapterData;
  },

  Section24Update(Section24Update){
    this.showPopupIncomeLossFromHousingProperty=false;
    //console.log("updated data Other Income",Section24Update);
    this.data2.section24=Section24Update;
    this.data2.section24.self_occupied.total_planned = this.data2.section24.self_occupied.total_planned ? this.data2.section24.self_occupied.total_planned*(-1) : 0;
  },

  previousDataUpdate(previousEmpData){
    this.showPopupIncomeFromPreviousEmployer=false;
    ////console.log("updated data previousEmpData",previousEmpData);
    this.data2.previousEmploymentDetails=previousEmpData;
  },

  otherIncomeUpdate(otherIncomeList){
    this.showPopupOtherIncome=false;
    //console.log("updated data Other Income",otherIncomeList);
    this.data2.otherIncome=otherIncomeList;
  },

  goBack() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      });
      this.showSuccessMsg = false;
    },

    async saveEssIT() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      });
      this.showSuccessMsg = false;
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";



// modal css previous employer

a.arrow.arrow-prev {
    font-size: 25px;
    font-weight: 600;
    margin: 0 10px;
}
.uploadingFile{
  width:197px;
}
.filtering{
  padding-top:5px;
}
a.arrow.arrow-next {
    font-size: 25px;
    font-weight: 600;
    margin: 0 10px;
}
img.docImage {
    width: 370px;
}
.custom-modal .modal-content .modal-footer {
  width: 100%;
}
span.delete-download {
    margin: 0 20px;
}
.add-new-document {
  width: 161px;
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
  border: 1px solid #37c6c0;
  border-radius: 4px;
  padding: 14px;
}

// End here


.col-10-new {
    -ms-flex: 0 0 83.33334%;
    -webkit-box-flex: 0;
    flex: 0 0 83.33334%;
    max-width: 83.33334%;
}

.left-box-6 {
    padding: 25px;
    border-right-width: 0;
    border: 1px solid #c9c9c9;
    border-left-width: 0;
    border-top-width: 0;
}

.right-box-6 {
    padding: 25px;
    border: 1px solid #c9c9c9;
    border-right-width: 0;
    border-top-width: 0;
    border-left-width: 0;
}

.amount-right {
    text-align: right;
}

.side-hr-lr {
    border: 1px solid #c9c9c9;
    border-top-width: 0;
    border-bottom-width: 0;
    height: 55px;
}

.view-proof-title {
  text-align: center;
  padding: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.view-proof-title-pointer {
  cursor: pointer;
}

.add-new-investment {
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #34c0be;
}

.add-new-investment-pointer {
  cursor: pointer;
}

.img-icon {
  transform: translate(-1px, 5px);
}

.atch-img {
  margin-right: 10px;
  transform: rotate(45deg);
}

.attachment-text {
  transform: translate(0px, 2px);
  position: absolute;
  font-size: 12px;
}

.othersection {
  padding: 15px 0px;
  background-color: #f2f2f2;
}

.img-icon-success {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.success-title-proof {
  font-size: 14px;
  font-weight: 600;
  position: absolute;
  margin-top: 5px;
}

.edit-investment-plan {
  position: relative;
  margin-top: 5px;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #5d409f;
}

.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}

.mask {
  width: 258.5px;
  height: 144px;
  border-radius: 8px;
  border: solid 1px #e9e9e9;
  background-color: #ffffff;
  padding: 20px 24px;
  margin: 20px 20px 20px 0px;
}
.center{
  margin: 500px ;
}
.resize{
  margin-left: 100px;
}
.bold-text{
    width: 345px;
  height: 24px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  margin-top: 40px;
}
.add-new{
    width: 68px;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #37c6c0;
}
.click-on-Add-New-t {
  width: 403px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
  // margin-left: -30px;
  margin-top: 10px;
}
.oval {
  // background-color: #ffa000;
  width: 75px;
  height: 75px;
  border-radius: 41px;
}

.add-btn-small {
  margin-top: 30px;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}

.img-user {
    margin: auto 0;
    text-align: center;
}

.month {
    margin-top: 8px;
    text-align: center;
}

.employee-fullname {
  text-transform: capitalize;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.employee-code {
  margin-bottom: 18px;
  font-size: 13px;
  font-weight: normal;
  color: #979797;
}

.salary-perks {
  margin-top: 30px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.salary-ctc {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.close-card {
    position: absolute;
    cursor: pointer;
    color: #5d409f;
    right: 10px;
    top: 4px;
}

.document-new-block {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18%;
  width: 400px;
  text-align: center;
}

.add-new-icon-document {
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
}

.add-new {
  height: 18px;
  margin: 3px 0 3px 6px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

#example {
  margin-top: 20px;
}

// #example .col-4 {
//   border: 1px solid #c9c9c9;
// }

// #example .col-4:not(:last-child) {
//   border-right-width: 0;
// }

#example .row:not(:last-child) .col-4 {
  border-bottom-width: 0;
}

#example .col-5 {
  border: 1px solid #c9c9c9;
}

#example .col-5:not(:last-child) {
  border-left-width: 0;
  border-right-width: 0;
}

// #example .row:not(:last-child) .col-5 {
//   border-bottom-width: 0;
// }

.first {
    height: 210px;
    padding: 32px;
    border-radius: 10px 0px 0px 10px;
    border: solid 1px #dddddd;
}    

.middle {
    //max-width:37%;
    height: 210px;
    padding: 32px;
    // border-radius: 10px 0px 0px 10px;
    // border: solid 1px #dddddd;
}

.last {
    // max-width: 37%;
    // flex: 0 0 37%;
    height: 210px;
    //padding: 32px;
    border-radius: 0px 10px 10px 0px;
    border: solid 1px #dddddd;
    border-left-width: 0;
}

.regime-title {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.badget-custom {
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color:#ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.icon-i {
  // margin: 0px 12px;
  transform: translate(0px, 7px);
}

.total-taxable-income {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.taxable-amount {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
  // margin-right: 20px;
  text-align: right;
}

.custom-width-block-19 {
  width: 14%;
}

.custom-width-block-13 {
  width: 13%;
}
.icon-move-right {
  float: right;
  margin-right: 7px;
}

.custom-col {
  margin-right: 0px;
}

.deduction-title {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.line {
  width: 1px;
  display: inline-block;
  height: 19px;
  margin: 0px 13px 0px 10px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.block-deductions {
  width: 404px;
  // height: 145px;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  border: solid 1px #efefef;
  background-color: #ffffff;
  cursor: pointer;
}

.block-deductions-title {
  margin-bottom: 8px;
}

.block-deductions-sub-title {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #444444;
}

.deduction-img {
  text-align: right;
  transform: translate(0px, 0px);
}

.amount-deduction {
  text-align: right;
  display: block;
}

.progress-bar-blue {
  margin-top: 10px;
  width: 340px;
  border-radius: 10px;
  height: 10px;
  background-color: #dadada;
}

.progress-target {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 94px;
}

.progress-target-full {
  background-color:#34c0be;
  border-radius: 10px;
  height: 10px;
  width: 340px;
}



  .modal {
    display: block;
    position: fixed;
    z-index: 6;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // background-color: rgba(0, 0, 0, 0.3);
    background: rgba(0, 0, 0, 0.60);
    -webkit-backdrop-filter: blur(14px);
    backdrop-filter: blur(10px);
  }

  /* Modal Content */

  .modal-content {
    background-color: white;
    margin: 150px auto 0px auto;
    z-index: 20;
    width: 30%;
    // height: 191px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    opacity: 0;
    padding: 30px 30px 30px 30px;
    -webkit-animation-name: showPopup;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
    // -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-fill-mode: forwards;

    .success-icon {
      // margin-bottom: 40px;
    }

    .success-text {
      font-size: $font-size-l1;
      font-weight: 600;
      // margin-bottom: auto;
      margin-left: 12px;
      color: #6e6e6e;
    }

    .message-text {
      font-size: $font-size-l1;
      margin-bottom: 20px;
      line-height: 25px;
      animation-delay: 0.7s;
      animation-name: fadeInRight;
      -webkit-animation-name: fadeInRight;
    }
    .btn-confirm-delete{
      display: flex;
      align-items: center;
      *:nth-child(n){
        margin-right: 20px;
      }
    }
    .warning {
      margin-bottom: 16px;
      text-align: center;
      height: 24px;
      width: 24px;
    }
    .btn-popup {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: $color-primary;
      color: $color-white;
    }
    .btn-popup-secondary {
      display: block;
      border-radius: 4px;
      min-width: 150px;
      padding: 0px 10px;
      height: 35px;
      background-color: #ffffff;
      border: #34c0be solid 2px;
      color: #34c0be;
    }

    .close-btn {
      position: relative;
      transform: scale(2);
      left: 230px;
      bottom: 20px;
      cursor: pointer;
    }
  }
  .success-img {
    position: relative;
    height: 24px;
    width: 24px;
    &.animated {
      animation-name: pulse;
      animation-iteration-count: infinite;
      animation-duration: 3s;
      -webkit-animation-name: pulse;
      -webkit-animation-iteration-count: infinite;
      -webkit-animation-duration: 3s;
    }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showc {
  0% {opacity: 1; transform: scale(0.2);}
  80% {transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}

@keyframes showt {
  0% { opacity: 1; transform: scale(0.2);}
  80% { transform: scale(1.1); opacity: 1;}
  100% { transform: scale(1); opacity: 1;}
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
@-webkit-keyframes fadeInRight {
  0% { padding-left: 25px; opacity: 0;}
  100% { padding-left: 0px; opacity: 1;}
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }

}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}
@-webkit-keyframes pulse {
  0% { transform: scale3d(1, 1, 1); }
  5% { transform: scale3d(1.2, 1.2, 1.2); }
  10% { transform: scale3d(1, 1, 1); }
  100% { transform: scale3d(1, 1, 1);}
}

@keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}
}
@-webkit-keyframes shake {
  1%, 9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%, 8% {
    transform: translate3d(2px, 0, 0);
  }

  3%, 5%, 7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%, 6% {
    transform: translate3d(4px, 0, 0);
  }
  10% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, 0, 0);}

}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
  
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

.bg-gray {
  background-color: #f2f2f2;
  padding: 10px 20px;
  height: 60px;
  margin: 20px 0;
}

.investment-alert-message {
  font-size: 14px;
  font-weight: 600;
}

.warning-img {
  height: 25px;
  width: 25px;
  margin-right: 15px;
  transform: translate(5px, 5px);
}

// ESS UI part CSS
.income-tax-summary-box  {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
}

.income-tax-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: 'Montserrat';
}

.col-10-new {
  -ms-flex: 0 0 83.33334%;
  -webkit-box-flex: 0;
  flex: 0 0 83.33334%;
  max-width: 83.33334%;
}

.back-btn-color-text {
  color: #40C6BF;
  font-weight: 600;
  text-align: center;
  margin: 12px 0px 0px;
  cursor: pointer;
}

.custom-col-3 {
  background: white;
  padding: 16px;
  margin: 5px;
  flex: 0 0 22%;  // 24% change to 22%
  max-width: 22%; // 24% change to 22%
  border-radius: 8px;
}

.sm-text-it-summary {
  color: #8d8d8d;
  font-size: 1.0rem;
  font-weight: 500;
  font-family: 'Montserrat';
}

.sm-sub-text-it-summary {
  font-weight: 600;
  margin-top: 8px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.sm-sub-text-right {
  font-family: 'Montserrat';
  font-size: 0.8rem;
}

// .add-btn-sm {
//   margin-top: 5px;
// }

.change-btn-color-text {
  border: #34C0BD solid 1px;
  background: #34C0BD;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
  min-width: 180px;
  min-height: 30px;
  text-align: center;
  padding: 10px;
  margin-top: 6px;
  cursor: pointer;
}

.col-bg-gray {
  background: #ebebeb;
  padding: 15px;
  border-radius: 8px;
}

.img-block {
  margin-top: 6px;
}

.heading-text {
  font-size: 1.125rem;
  font-weight: bold;
  color: #40C6BF;
  margin-bottom: 9px;
  font-family: 'Montserrat';
}

.sub-heading-details-sm {
  color: #8d8d8d;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.1rem;
  font-family: 'Montserrat';
}

.total-amount-text {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 14px;
  color: #5a5a5a;
  font-family: 'Montserrat';
}

.arrow-icon-it {
  position: relative;
  top: calc(50% - 10px);
}

.arrow-left-align {
  text-align: end;
  cursor: pointer;
}

.cursor-point {
  cursor: pointer;
}
</style>
